// extracted by mini-css-extract-plugin
module.exports = {"selected":"choose-payment-system_selected__2aT83","paynet":"choose-payment-system_paynet__3pWUH","dropItem":"choose-payment-system_dropItem__2GO71"};